import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  selectedLanguage: 'en',
  direction: 'ltr'
};

const languageSlice = createSlice({
  name: 'languageReducer',
  initialState,
  reducers: {
    setSelectLanguage: (state, action) => {
      console.error('action.payload', action.payload);
      state.selectedLanguage = action.payload;
    },
    setDirection: (state, action) => {
      state.direction = action.payload;
    }
  }
});

export const { setSelectLanguage, setDirection } = languageSlice.actions;

export default languageSlice.reducer;
